import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _OutputTypeMap;

import { Checkbox, HStack, Text, VStack } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { utcDateString2localDateString } from 'src/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ComparedColumn = function ComparedColumn(_ref) {
  var row = _ref.row,
      data = _ref.data,
      _ref$showOnTop = _ref.showOnTop,
      showOnTop = _ref$showOnTop === void 0 ? false : _ref$showOnTop,
      _ref$normalizeFn = _ref.normalizeFn,
      normalizeFn = _ref$normalizeFn === void 0 ? function (v) {
    return v;
  } : _ref$normalizeFn;
  var depth = row.depth;
  var isTopLevel = depth === 0;
  var expanded = row.getIsExpanded();
  var archived = row.original.archived;
  var color = archived ? 'gray.100' : 'blackAlpha.300';
  return /*#__PURE__*/_jsx(Text, {
    w: "full",
    minH: "1em",
    align: "left",
    fontWeight: isTopLevel && expanded ? 'bold' : 'normal',
    textColor: color,
    e2eid: "drug_OutputCompareTableColumns_Text",
    children: !showOnTop && expanded && isTopLevel ? '' : data === undefined ? '-' : normalizeFn(data)
  });
};

var getMeta = function getMeta(row) {
  var getIsExpanded = row.getIsExpanded,
      depth = row.depth;
  var expanded = getIsExpanded();
  var isTopLevel = depth === 0;
  return {
    skip: isTopLevel && expanded
  };
};

var renderNormalCell = function renderNormalCell(info) {
  return /*#__PURE__*/_jsx(ComparedColumn, {
    row: info.row,
    data: info.getValue(),
    e2eid: "drug_OutputCompareTableColumns_ComparedColumn"
  });
};

export var OutputType;

(function (OutputType) {
  OutputType["prescription"] = "prescription";
  OutputType["outgoing"] = "outgoing";
})(OutputType || (OutputType = {}));

export var OutputTypeMap = (_OutputTypeMap = {}, _defineProperty(_OutputTypeMap, OutputType.prescription, 0), _defineProperty(_OutputTypeMap, OutputType.outgoing, 1), _OutputTypeMap);
export var renderHeaderCheckboxes = function renderHeaderCheckboxes(isAllRowsSelected, onSelectAll, t) {
  var handleSelectAll = function handleSelectAll(type) {
    return function (e) {
      return onSelectAll(type, e.target.checked);
    };
  };

  return /*#__PURE__*/_jsxs(VStack, {
    w: "full",
    e2eid: "drug_OutputCompareTableColumns_VStack",
    children: [/*#__PURE__*/_jsxs(HStack, {
      w: "full",
      e2eid: "drug_OutputCompareTableColumns_HStack",
      children: [/*#__PURE__*/_jsx(Checkbox, {
        isChecked: isAllRowsSelected(OutputType.prescription),
        onChange: handleSelectAll(OutputType.prescription),
        size: "lg",
        e2eid: "drug_OutputCompareTableColumns_Checkbox"
      }), /*#__PURE__*/_jsx(Text, {
        e2eid: "drug_OutputCompareTableColumns_Text",
        children: t('common:table.prescription', '處方')
      })]
    }), /*#__PURE__*/_jsxs(HStack, {
      w: "full",
      e2eid: "drug_OutputCompareTableColumns_HStack",
      children: [/*#__PURE__*/_jsx(Checkbox, {
        isChecked: isAllRowsSelected(OutputType.outgoing),
        onChange: handleSelectAll(OutputType.outgoing),
        size: "lg",
        e2eid: "drug_OutputCompareTableColumns_Checkbox"
      }), /*#__PURE__*/_jsx(Text, {
        e2eid: "drug_OutputCompareTableColumns_Text",
        children: t('common:table.outgoing', '出庫')
      })]
    })]
  });
};
var columnHelper = createColumnHelper();
export var getOutputCompareTableColumns = function getOutputCompareTableColumns(_ref2) {
  var t = _ref2.t,
      isViewMode = _ref2.isViewMode,
      onSelectAll = _ref2.onSelectAll,
      isAllRowsSelected = _ref2.isAllRowsSelected;
  return [columnHelper.display({
    id: 'selection',
    cell: function cell(_ref3) {
      var row = _ref3.row;
      var index = row.index,
          depth = row.depth;
      var isTopLevel = depth === 0;
      var expanded = row.getIsExpanded();

      if (isTopLevel) {
        var archived = row.original.archived;
        var color = archived ? 'gray.100' : 'blackAlpha.300';
        return /*#__PURE__*/_jsx(Text, {
          w: "full",
          minH: "1em",
          align: isTopLevel ? 'left' : 'right',
          fontWeight: expanded ? 'bold' : 'normal',
          textColor: color,
          e2eid: "drug_OutputCompareTableColumns_Text_9",
          children: expanded ? "".concat(index + 1, ". ").concat(row.original.name) : ''
        });
      } else if (!isViewMode) {
        return /*#__PURE__*/_jsx(Checkbox, {
          isChecked: row.getIsSelected(),
          isDisabled: !row.getCanSelect() || row.original._disable,
          onChange: row.getToggleSelectedHandler(),
          size: "lg",
          e2eid: "drug_OutputCompareTableColumns_Checkbox"
        });
      } else {
        return null;
      }
    },
    header: function header() {
      if (isViewMode) {
        return null;
      }

      return renderHeaderCheckboxes(isAllRowsSelected, onSelectAll, t);
    },
    meta: {
      getMeta: function getMeta(row) {
        var _getAllCells;

        var getIsExpanded = row.getIsExpanded,
            getAllCells = row.getAllCells,
            depth = row.depth;
        var expanded = getIsExpanded();
        var isTopLevel = depth === 0;
        return {
          colspan: isTopLevel && expanded ? ((_getAllCells = getAllCells()) === null || _getAllCells === void 0 ? void 0 : _getAllCells.length) - 1 || 0 : 0
        };
      }
    },
    size: 40
  }), columnHelper.accessor('name', {
    cell: function cell(info) {
      return /*#__PURE__*/_jsx(ComparedColumn, {
        row: info.row,
        data: info.getValue(),
        e2eid: "drug_OutputCompareTableColumns_ComparedColumn"
      });
    },
    header: function header() {
      return t('common:table.productName', '商品名稱');
    }
  }), columnHelper.accessor('amount', {
    cell: renderNormalCell,
    header: function header() {
      return t('common:table.medicineOrOutputAmount', '發藥量/出庫量');
    },
    size: 100,
    meta: {
      getMeta: getMeta
    }
  }), columnHelper.accessor('returned', {
    cell: function cell(info) {
      return /*#__PURE__*/_jsx(ComparedColumn, {
        row: info.row,
        data: info.getValue(),
        normalizeFn: function normalizeFn(v) {
          return v ? t('deliverynote:drugReturned', '退藥') : '-';
        },
        e2eid: "drug_OutputCompareTableColumns_ComparedColumn_12"
      });
    },
    header: function header() {
      return t('client:table.returnDrug', '退藥');
    },
    size: 90,
    meta: {
      getMeta: getMeta
    }
  }), columnHelper.accessor('single_amount', {
    cell: renderNormalCell,
    header: function header() {
      return t('common:table.singleAmount', '次量');
    },
    size: 90,
    meta: {
      getMeta: getMeta
    }
  }), columnHelper.accessor('frequency', {
    cell: renderNormalCell,
    header: function header() {
      return t('common:table.frequency', '頻率');
    },
    size: 100,
    meta: {
      getMeta: getMeta
    }
  }), columnHelper.accessor('days', {
    cell: renderNormalCell,
    header: function header() {
      return t('common:table.days', '天數');
    },
    size: 100,
    meta: {
      getMeta: getMeta
    }
  }), columnHelper.accessor('updated_at', {
    cell: function cell(info) {
      return /*#__PURE__*/_jsx(ComparedColumn, {
        row: info.row,
        data: info.getValue(),
        normalizeFn: function normalizeFn(v) {
          return v ? utcDateString2localDateString(v, 'YYYY/MM/DD HH:mm') : '';
        },
        e2eid: "drug_OutputCompareTableColumns_ComparedColumn_13"
      });
    },
    header: function header() {
      return t('common:table.dispatchOrPrescriptionUpdateTime', '醫師處方更新/出庫時間');
    },
    size: 100,
    meta: {
      getMeta: getMeta
    }
  }), columnHelper.accessor('compliance', {
    cell: renderNormalCell,
    header: function header() {
      return t('common:table.compliance', '醫囑');
    },
    size: 160,
    meta: {
      getMeta: getMeta
    }
  })];
};